import React, { Component } from "react";
import { Button } from "react-bootstrap";
import { InputFieldFloatingLabel as InputField } from "../../../../common/custom-form/select-filter.component";
import { Conf_Message_Allowed_Extension, MAX_LENGTH } from "../../../../../constants/external-constants";
import { ConfirmationModal } from "../../../../common/modal/modal.component";
import { NotificationModal } from "../../../../common/modal/notification-modal.component";
import { TRANSLATIONS as translation,  } from '../../../../../utils/constant.utils';
import { NoSubscription } from "../../../dashboard/no-subscription/no-subscription.component";
import Translation  from "../../../../common/translation/translation.component";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { LocationSiteFormActions } from "../../../../../store/external/inventory/locationsite/locationsite-details.reducer";
import { bindActionCreators } from 'redux';
import { actions } from "react-redux-form";
import { DATA_TYPE } from "../../../../../constants/external-constants";
import { isObjectEqual, convertToDecimal } from "../../../../../utils/helpers.utils";
import store from "../../../../../store";
import CustomSearchableDropdownWrapper from "../../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper";

class LocationFormView extends Component {
    constructor(props) {
        super(props);
        this.ConfirmationModal = React.createRef();
        this.state = {
            viewDetailPage: false,
            saveModal: {
                title: "",
                messageBody: "",
                confirmAction: () => { }
            },
            saveNotif: {
                show: false,
                title: "",
                message: ""
            },
            isSaving: false,
            activeDropdown: null,
            originalPlanComponentData:{},
            isLoading: true,
            files: [],
        }
        this.UploadButton = React.createRef();
    }

    componentDidMount() {
         this.fetchLocationData();
    }

    fetchLocationData = async () => {
         const { getLocationCountryList, isCreateNew, locationId, getLocationSiteFormDetails } = this.props;

         if (!isCreateNew && locationId > 0) {
             await getLocationSiteFormDetails(locationId);
        }
         const { locationSite } = this.props.locationSiteForm;

         await getLocationCountryList(1, locationSite.countryName);


        this.setState({ isLoading: false });
    }

    componentWillUnmount() {
        this.props.resetLocationForm();
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '' || locale === undefined)
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    handleToggleDropdown = (index, isShow = false) => {
        this.setState(prevState => ({
            activeDropdown: prevState.activeDropdown === index && !isShow ? null : index
        }));
    }   

    onChangeCountrySelection(e) {
        const { getSelectedCountryCode, locationSiteDetails } = this.props;
        const { countriesList } = locationSiteDetails;
        const countryName = countriesList.find(x => x.Key === e)?.Value ?? null;
        if (e != null) {
            getSelectedCountryCode(e, countryName);
        }
    }

    handleButtonConfirmation = async (locationId, validate = 1) => {
        const { saveLocationSite, isCreateNew } = this.props;

        this.setState({
            isSaving: true
        });

        var result = await saveLocationSite(locationId, validate);

        this.setState({
            isSaving: false
        });

        if (result.success === false) {
            if (result.isValid) {
                if (!isCreateNew) {
                    const confirmMessage = this.toLocaleLanguage("save_confirmation");
                    const modalTitle = this.toLocaleLanguage("call_save", false);
                    var confirmAction = () => this.handleButtonConfirmation(locationId, 0);
                    this.toggleSaveModal(true, modalTitle, confirmMessage, confirmAction);
                    return;
                }
                else {
                    this.handleButtonConfirmation(locationId, 0);
                    return;
                }

            }
            else {
                this.toggleSaveModal(false);
                this.toggleSaveNotif(true, this.toLocaleLanguage("modal_error_title", false), result.message);
                return;
            }
        }
        else if (result.success === true) {
            const modalMessage = result.message;
            const modalTitle = this.toLocaleLanguage("success_modal_title");

            this.toggleSaveModal(false);
            this.toggleSaveNotif(true, modalTitle, modalMessage);
            this.setState({
                isLoading: true
            })
            this.fetchLocationData();
            return;
        }
    }

    toggleSaveNotif = (isShow, title, message) => {
        const { saveNotif } = this.state;
        const { handleCloseForm, resetLocationForm, getLocationSiteFormDetails } = this.props

        this.setState({
            saveNotif: {
                ...saveNotif,
                show: isShow,
                title: title ?? "",
                message: message ?? "",
            }
        });

        if (!isShow && saveNotif.message === this.toLocaleLanguage("location_created")) {
            handleCloseForm();
            resetLocationForm();
        }
        if(!isShow && saveNotif.message === "Location has been updated"){
            getLocationSiteFormDetails(this.props.locationId);
        }

    }

    toggleSaveModal = (isShow, title, message, confirmAction = () => { }) => {
        const { saveModal } = this.state;

        if (isShow) {
            this.ConfirmationModal.current.handleShow();
        }
        else {
            this.ConfirmationModal.current.handleClose();
        }

        this.setState({
            saveModal: {
                ...saveModal,
                title: title ?? "",
                messageBody: message ?? "",
                confirmAction: confirmAction
            },
        });
    }

    disableSaveChanges = () => {
        const { $form, locationSiteForm } = this.props
        const { locationSite } = locationSiteForm;

        const isFieldEmpty = !locationSite.locationSiteId || !locationSite.address1 || !locationSite.city | !locationSite.locationState || !locationSite.zip || !locationSite.countryCode;

            
            if (isFieldEmpty) {
                return true;
            }
            
            const unchangedLocationDetails = !$form.loadedValue ? true : isObjectEqual($form.loadedValue.locationSite, locationSite);


            const removeFiles = (obj, excludedProps = []) => {
                const cloned = { ...obj };
                excludedProps.forEach(prop => delete cloned[prop]);
                return cloned;
            };


            const excludedProps = ['files'];

            const cleanData = (obj) => {
                
                const clonedObj = JSON.parse(JSON.stringify(obj));
              
                if (clonedObj.locationSite) {
                    clonedObj.locationSite = removeFiles(
                    clonedObj.locationSite,
                    excludedProps
                  );
                }
              
                return clonedObj;
              };


            const originalValue = cleanData($form.loadedValue);
            const newValue = cleanData(locationSiteForm);
            const unchangedLocationFormDetails = !$form.loadedValue ? true : isObjectEqual(originalValue, newValue);

            return unchangedLocationDetails && unchangedLocationFormDetails;
    }
    convertToDecimal = (value) => {
        if (typeof value === "string") return value;
        const result = (Math.round(value * 100) / 100).toFixed(2);

        return result;
    }

    loadMoreVendor = (searchString) => {
        const { locationSiteDetails, getLocationCountryList } = this.props;

        getLocationCountryList(locationSiteDetails.countryListPage + 1, searchString);
    }
    handleSearchVendor = (query) => {        
        const { getLocationCountryList } = this.props;
            getLocationCountryList(1, query);
    }
    render() {
        const { isLoading } = this.state;
        const { locationSiteDetails, locationSiteForm, locationId } = this.props;
        const { locationSite } = locationSiteForm;
        const { locationSiteId, address1, city, locationState, zip, countryCode } = locationSite;


        const requiredFields = [
            locationSiteId,
            address1,
            city,
            locationState,
            zip,
            countryCode,
        ];

        const enableSaveButton = requiredFields.some((field) => !field);

        return (
            <>
                <div className={"details-container add-plan-catalogue"}>
                {isLoading ? 
                    <NoSubscription/> :
                    <div className="add-plan-catalogue dispute-container contract-form-container">
                        <div className="dispute-container details-field-container mb-3 capital-uppercase">

                            <InputField
                                className="form-control"
                                type="text"
                                label={<Translation translationKey={"location_site_id_capital"} />}
                                value={locationSiteForm.locationSite.locationSiteId}
                                fieldProp='locationSiteForm.locationSite.locationSiteId'
                                maxLength={MAX_LENGTH.limit_100}
                                disabled={false}
                                requiredField
                                placeholder={this.toLocaleLanguage("enter_text_placeholder")}
                            />

                            <InputField
                                className="form-control"
                                type="text"
                                label={<Translation translationKey={"address_1_capital"} />}
                                value={locationSiteForm.locationSite.address1}
                                fieldProp='locationSiteForm.locationSite.address1'
                                maxLength={MAX_LENGTH.limit_255}
                                disabled={false}
                                requiredField
                                placeholder={this.toLocaleLanguage("enter_text_placeholder")}
                            />

                            <InputField
                                className="form-control"
                                type="text"
                                label={<Translation translationKey={"address_2_capital"} />}
                                value={locationSiteForm.locationSite.address2 ?? ""}
                                fieldProp='locationSiteForm.locationSite.address2'
                                maxLength={MAX_LENGTH.limit_255}
                                disabled={false}
                                placeholder={this.toLocaleLanguage("enter_text_placeholder")}
                             />

                            <CustomSearchableDropdownWrapper 
                                label={this.toLocaleLanguage("country")}
                                options={locationSiteDetails.countriesList}
                                selected={locationSiteForm.locationSite.countryId}
                                onChange={(e) => this.onChangeCountrySelection(e)}
                                requiredField
                                placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                fieldProp='locationSiteForm.locationSite.countryId'
                                tagName='tagName'
                                optionLabelKey={{
                                    Key: "Key",
                                    Value: "Value"
                                }}
                                maxLength={MAX_LENGTH.limit_100}
                                onSearchChange={this.handleSearchVendor}
                                onLoadMore={(val) => this.loadMoreVendor(val)}
                                isLoading={!this.props?.locationSiteDetails?.isCountryListLoaded}
                                hasMore={locationSiteDetails?.hasMoreCountry}
                                isNoErrorMessage={true}
                            />

                            <InputField
                                className="form-control"
                                type="text"
                                label={<Translation translationKey={"city_capital"} />}
                                value={locationSiteForm.locationSite.city}
                                fieldProp='locationSiteForm.locationSite.city'
                                maxLength={MAX_LENGTH.limit_100}
                                disabled={false}
                                requiredField
                                placeholder={this.toLocaleLanguage("enter_text_placeholder")}
                             />

                            <InputField
                                className="form-control"
                                type="text"
                                label={<Translation translationKey={"state_capital"} />}
                                value={locationSiteForm.locationSite.locationState}
                                fieldProp='locationSiteForm.locationSite.locationState'
                                maxLength={MAX_LENGTH.limit_100}
                                disabled={false}
                                requiredField
                                placeholder={this.toLocaleLanguage("enter_text_placeholder")}
                             />

                             <InputField
                                className="form-control"
                                type="text"
                                label={<Translation translationKey={"zip_capital"} />}
                                value={locationSiteForm.locationSite.zip}
                                fieldProp='locationSiteForm.locationSite.zip'
                                maxLength={MAX_LENGTH.limit_15}
                                disabled={false}
                                requiredField
                                placeholder={this.toLocaleLanguage("enter_text_placeholder")}
                              />

                            <InputField
                                className="form-control"
                                type="text"
                                label={`${this.toLocaleLanguage('country_code')}`}
                                value={locationSiteForm.locationSite.countryCode}
                                fieldProp='locationSiteForm.locationSite.countryCode'
                                disabled={true}
                            />


                            <InputField
                                className="form-control"
                                type="text"
                                label={<Translation translationKey={"location_type_capital"} />}
                                value={locationSiteForm.locationSite.locationType ?? ""}
                                fieldProp='locationSiteForm.locationSite.locationType'
                                maxLength={MAX_LENGTH.inputText}
                                disabled={false}
                                placeholder={this.toLocaleLanguage("enter_text_placeholder")}
                            />                

                        </div>


                        <div className='dispute-save-btn save-btn-container'>
                            <ConfirmationModal
                                ref={this.ConfirmationModal}
                                title={this.state.saveModal.title}
                                messageBody={this.state.saveModal.messageBody}
                                confirmAction={this.state.saveModal.confirmAction}
                                closeLabel={this.toLocaleLanguage("cancel_button", false)}
                                confirmLabel={this.toLocaleLanguage("yes_button", false)}
                                disabled={this.state.isSaving}
                            />

                            <NotificationModal
                                show={this.state.saveNotif.show}
                                title={this.state.saveNotif.title}
                                message={this.state.saveNotif.message}
                                handleModal={() => this.toggleSaveNotif(false)}
                                customClass={'comment-notification-modal modal-text-bold notification-footer'}
                            />
                        </div>
                    </div>
                    }
                </div>
                <div className="save-btn-container justify-content-between">

                    {/* DELETE BUTTON */}
                    {this.props.isReadAndWrite && (
                        <div className="tooltip-container">
                            <Button
                                className="delete-details-btn btn btn-danger"
                                type="button"
                                onClick={this.handleDeleteInvoice} 
                            >
                                Delete Location
                            </Button>

                            <span className="tooltip-text-save start-50 translate-middle-x top--50">
                                {this.toLocaleLanguage("delete_location_details", false)}
                            </span>
                        </div>
                    )}
                    {this.props.isReadAndWrite && (
                        <div className="tooltip-container">
                            <div className="btn-tooltiptext">
                            <Button
                                className="save-details-btn btn btn-primary"
                                disabled={
                                    this.props.isCreateNew
                                        ? enableSaveButton
                                        : this.disableSaveChanges()
                                }
                                type="button"
                                onClick={() => this.handleButtonConfirmation(locationId)}
                            >
                                Save Changes
                            </Button>
                                <div className="save-tooltip-text-container">
                                    <span className="tooltip-text-save">
                                        {this.toLocaleLanguage("save_location_details")}
                                    </span>
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </>     
        )
    }
}

export default withRouter(connect(
    state => {
        const { locationSiteDetails, translation } = state;
        const { locationSiteForm, forms: { locationSiteForm: { $form } } } = state.form;
        return {
            ...translation,
            locationSiteDetails,
            locationSiteForm,
            $form
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, LocationSiteFormActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        },
        FormLoad: (model, data) => {
            dispatch(actions.load(model, data));
        }
    })
)(LocationFormView));